import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    contentContainer: {
        marginTop: "15px",
    },
    inputTextField: {
        maxWidth: 450,
    },
    buttonBox: {
        width: "250px",
        textAlign: "left",
    },
    infoContainer: {
        marginTop: "20px",
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        "@media (max-width: 620px)": {
            flexDirection: "column",
        },
    },
    buttonsContainer: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-end",
    },
}));
